import { useCallback, useState } from 'react';

const getSessionIdFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get('session_id') || undefined;
};

const setSessionIdInUrl = (sessionId: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('session_id', sessionId);

  window.history.replaceState({}, '', `${window.location.pathname}?${urlParams.toString()}`);
};

export default function useSessionId() {
  // Initially, load the session id from the url
  const [sessionId, setSessionId] = useState<string | undefined>(getSessionIdFromUrl());

  // When the session id changes, update the url and the state
  const updateSessionId = useCallback((newSessionId: string) => {
    setSessionId(newSessionId);
    setSessionIdInUrl(newSessionId);
  }, []);

  return {
    sessionId,
    setSessionId: (newSessionId: string) => {
      updateSessionId(newSessionId);
    },
  };
}
